import React from 'react';
function CornerTopRightRadius({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M14.1668 14.1666L14.1668 10.8483C14.1668 8.07857 11.9215 5.83329 9.15186 5.83329L5.8335 5.83329"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default CornerTopRightRadius;
